import type { createStore } from "jotai";
import {
  getShouldHandleConsent,
  isSomeCookieConsentGranted,
} from "./components/CookieBanner/consent";
import { onesaasConsentAtom } from "./components/CookieBanner/onesaas-consent-cookie";
import { CrossDomainStorage } from "./helpers/crossDomainStorage";

type UtmKey = `utm_${string}`;

interface UtmParameters {
  [key: UtmKey]: string;
  gclid?: string;
}

const isUtmParameters = (key: string): key is keyof UtmParameters =>
  key.startsWith("utm_") || key === "gclid";

const getUtmParametersFromUrl = (): UtmParameters => {
  const url = new URL(window.location.href);
  const utmParams: UtmParameters = {};

  url.searchParams.forEach((value, key) => {
    if (isUtmParameters(key)) {
      utmParams[key] = value;
    }
  });

  Object.keys(utmParams).forEach((key) => {
    url.searchParams.delete(key);
  });

  window.history.replaceState({}, "", url);

  return utmParams;
};

const saveUtms = async (utms: UtmParameters) => {
  for (const [key, value] of Object.entries(utms)) {
    document.cookie = `${key}=${value}`;
    await CrossDomainStorage.getInstance().append(key, value);
  }
};

export const storeUtmParametersInCookie = async (
  store: ReturnType<typeof createStore>
) => {
  try {
    const utmParams = getUtmParametersFromUrl();

    if (!getShouldHandleConsent()) {
      return await saveUtms(utmParams);
    }

    const unsub = store.sub(onesaasConsentAtom, async () => {
      try {
        const atomValue = store.get(onesaasConsentAtom);
        if (isSomeCookieConsentGranted(atomValue)) {
          await saveUtms(utmParams);
          unsub();
        }
      } catch (error) {
        console.error("Failed to handle UTM param", error);
      }
    });
  } catch (error) {
    console.error("Failed to handle UTM param", error);
  }
};
